export default "__VITE_ASSET__OtdkOmgp__"